import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  makeStyles,
} from "@material-ui/core";
import { Warning } from "@material-ui/icons";
import { useTranslation } from "../hooks/useTranslation";

const useStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      borderRadius: "12px",
      minWidth: "400px",
    },
  },
  dialogTitle: {
    backgroundColor: "var(--ikaro-orange-primary)",
    color: "var(--ikaro-text-white)",
    padding: theme.spacing(2),
    "& .MuiTypography-h6": {
      fontWeight: "bold",
      fontSize: "1.1rem",
    },
  },
  dialogContent: {
    padding: theme.spacing(3),
    textAlign: "center",
  },
  warningIcon: {
    fontSize: "3rem",
    color: "var(--ikaro-orange-primary)",
    marginBottom: theme.spacing(2),
  },
  bodyText: {
    color: "var(--ikaro-gray-dark)",
    marginBottom: theme.spacing(2),
    fontSize: "1rem",
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
    justifyContent: "center",
    gap: theme.spacing(2),
  },
  cancelButton: {
    color: "var(--ikaro-gray-dark)",
    borderColor: "var(--ikaro-gray-medium)",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "var(--ikaro-gray-light)",
    },
  },
  confirmButton: {
    backgroundColor: "var(--ikaro-orange-primary)",
    color: "var(--ikaro-text-white)",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "var(--ikaro-orange-hover)",
    },
  },
}));

const SoftDeleteJobDialog = ({ open, job, onClose, onConfirm }) => {
  const classes = useStyles();
  const { t } = useTranslation("jobs");

  const jobLabel =
    job?.job_name ||
    (job?.id != null ? `#${job.id}` : "");

  const handleConfirm = () => {
    if (job) {
      onConfirm(job);
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.dialog}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle className={classes.dialogTitle}>
        <Box display="flex" alignItems="center">
          <Warning style={{ marginRight: "8px" }} />
          {t("actions.softDeleteConfirmTitle")}
        </Box>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <Warning className={classes.warningIcon} />
        <Typography className={classes.bodyText}>
          {t("actions.softDeleteConfirmMessage", { jobLabel })}
        </Typography>
      </DialogContent>

      <DialogActions className={classes.dialogActions}>
        <Button
          variant="outlined"
          className={classes.cancelButton}
          onClick={onClose}
        >
          {t("actions.softDeleteCancel")}
        </Button>
        <Button
          variant="contained"
          className={classes.confirmButton}
          onClick={handleConfirm}
        >
          {t("actions.softDeleteConfirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SoftDeleteJobDialog;
